// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeaderBlock_root__L3c2C","content":"PageHeaderBlock_content__3ZqyZ","title":"PageHeaderBlock_title__tRkBQ","text":"PageHeaderBlock_text__flMhS"};